import React from 'react';
import { Quest, QuestCategory } from '../types';
import QuestCard from './QuestCard';

interface QuestSelectionProps {
  offeredQuests: { [key: string]: Quest | null };
  categoryOrder: QuestCategory[];
  onChoose: (quest: Quest) => void;
  onReject: (quest: Quest) => void;
  categoryCounts: Record<string, number>;
  isMaxQuestsReached: boolean;
  onShowDetails: (quest: Quest) => void;
  completedQuestIds: number[];
}

export const QuestSelection: React.FC<QuestSelectionProps> = ({ offeredQuests, categoryOrder, onChoose, onReject, categoryCounts, isMaxQuestsReached, onShowDetails, completedQuestIds }) => {
  return (
    <div className="bg-slate-200/50 dark:bg-slate-800/50 rounded-xl p-6 border border-slate-300 dark:border-slate-700">
      <h2 className="text-3xl font-bold text-slate-900 dark:text-slate-100 mb-1">Choose Your Next Quest</h2>
      <p className="text-slate-600 dark:text-slate-400 mb-6">Here are your next great adventures! Choose one to add it to your active quests.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {categoryOrder.map(category => {
          const quest = offeredQuests[category];
          
          if (!quest) {
            return (
              <div key={category}>
                <div className="h-full bg-white dark:bg-slate-800 rounded-xl flex items-center justify-center p-6 min-h-[240px]">
                  <p className="text-slate-500">Loading quest...</p>
                </div>
              </div>
            );
          }

          const isCategoryFull = (categoryCounts[quest.category] || 0) >= 2;
          const isChoiceDisabled = isMaxQuestsReached || isCategoryFull;
          let disabledReason = '';
          if (isMaxQuestsReached) {
            disabledReason = 'Maximum of 5 active quests reached.';
          } else if (isCategoryFull) {
            disabledReason = `Maximum of 2 "${quest.category}" quests reached.`;
          }
          
          return (
            <div key={category}>
              <QuestCard 
                quest={quest} 
                variant="offer" 
                onChoose={onChoose}
                onReject={onReject}
                onShowDetails={onShowDetails}
                isChoiceDisabled={isChoiceDisabled}
                disabledReason={disabledReason}
                completedQuestIds={completedQuestIds}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuestSelection;